import React from 'react';
import { useIntl } from 'react-intl';

import { SfaFatalError } from '@futrli/shared-services';

import Box from 'carbon-react/lib/components/box';
import Button from 'carbon-react/lib/components/button';
import Typography from 'carbon-react/lib/components/typography';

import image from './images/logged-out.svg';

interface SfaCancelByUserFatalErrorProps {
  onBackToSetup: () => void;
}

export const SfaCancelByUserFatalError = ({ onBackToSetup }: SfaCancelByUserFatalErrorProps) => {
  const intl = useIntl();

  const text = {
    title: intl.formatMessage({
      id: 'onboarding.sfa.futrli_setup_is_incomplete',
      defaultMessage: 'Futrli setup is incomplete'
    }),
    subtitle: intl.formatMessage({
      id: 'onboarding.sfa.you_still_need_to_link_your_sfa_business',
      defaultMessage: 'You still need to link your Sage for Accountants business to a Futrli organisation.'
    }),
    text1: intl.formatMessage({
      id: 'onboarding.sfa.things_to_consider_before_linking',
      defaultMessage: 'Things to consider before linking a Futrli organisation:'
    }),
    bullet1: intl.formatMessage({
      id: 'onboarding.sfa.existing_org_choose_the_correct_one',
      defaultMessage: 'For an existing organisation, ensure to select the correct one before you continue.'
    }),
    bullet2: intl.formatMessage({
      id: 'onboarding.sfa.new_org_ensure_all_details_correct',
      defaultMessage: 'For a new organisation, ensure you have entered all the details correctly before you continue.'
    }),
    text2: intl.formatMessage({
      id: 'onboarding.sfa.select_back_to_futrli_setup_to_link_org',
      defaultMessage:
        "Select 'Back to Futrli set up' to link an organisation now. Or you can come back and do it later."
    }),
    buttonText: intl.formatMessage({
      id: 'onboarding.sfa.back_to_futrli_setup',
      defaultMessage: 'Back to Futrli setup'
    })
  };

  const textBlock = (
    <>
      {text.text1}
      <Typography variant="ul" my={3}>
        <Typography as="li" size="L">
          {text.bullet1}
        </Typography>
        <Typography as="li" size="L">
          {text.bullet2}
        </Typography>
      </Typography>
      {text.text2}
      <Box mt={4}>
        <Button onClick={onBackToSetup}>{text.buttonText}</Button>
      </Box>
    </>
  );

  return <SfaFatalError image={image} {...text} text={textBlock} />;
};
